<template>
  <div>
    <title>规格管理</title>
    <section class="goodsDet">
      <!--S 公用头部切换-->
      <GoodsInfoTab :active="currentTit"></GoodsInfoTab>
      <!--E 公用头部切换-->
      <!-- S 规格信息组件 -->
      <KindInfoPage></KindInfoPage>
      <!-- E 规格信息组件 -->
    </section>
    

  </div>
</template>
<script>
export default {
  name: 'GoodsSpecifyMange',
  data () {
    return {
      currentTit:1, //当前选中菜单
    }
  },
  components: {
    GoodsInfoTab: resolve => require(["@/components/GoodsFolder/GoodsInfoTab.vue"],resolve),
    KindInfoPage: resolve => require(["@/components/common/KindInfoPage.vue"],resolve), // 规格信息组件
  },
  methods: {

  },
  created() {
    
  },
  mounted () {
    sessionStorage.setItem('operateNotSaved','');
  },
}
</script>
<style scoped>
.goodsDet {
  position: relative;
  padding: 84px 20px 85px 20px;
  height: calc(100% - 169px);
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/GoodsFolder/GoodsCommodity/GoodsSpecifyMange.vue